"use client";

import { FileCode2, SquareDashedBottomCode } from "lucide-react";

import { CurvedTab } from "@acme/ui/curved-tab";
import { Tabs, TabsList } from "@acme/ui/tabs";
import { StudioMode } from "@acme/validators";

import { useStudioStore } from "../../_hooks/use-studio-store";

export function RuleEditorTabs() {
  const setMode = useStudioStore((state) => state.setMode);
  const mode = useStudioStore((state) => state.mode);
  return (
    <Tabs
      value={mode}
      onValueChange={(v: string) => setMode(v as StudioMode)}
      className="relative -bottom-0.5 flex flex-col"
    >
      <TabsList className="p-0" variant="underline">
        <div className="relative flex h-full w-full flex-nowrap">
          <CurvedTab value={StudioMode.Config}>
            <div className="mr-3 ml-1.5 inline-flex flex-1 items-center gap-1.5 overflow-hidden align-top text-xs whitespace-nowrap">
              <SquareDashedBottomCode className="size-4" />
              <span>Query</span>
            </div>
          </CurvedTab>
          <CurvedTab value={StudioMode.JsAstGrep} className="-ml-3">
            <div className="mr-3 ml-1.5 inline-flex flex-1 items-center gap-1.5 overflow-hidden align-top text-xs whitespace-nowrap">
              <FileCode2 className="size-4" />
              <span>Codemod</span>
            </div>
          </CurvedTab>
        </div>
        <svg className="hidden" aria-hidden="true" focusable="false">
          <defs>
            <symbol id="tab-geometry-left" viewBox="0 0 214 36">
              <title>Tab geometry left</title>
              <path d="M214 0v36H0v-2c4.5 0 9-3.5 9-8V16C9 8.45 9 4.68 11.34 2.34S17.45 0 25 0h189Z" />
            </symbol>

            <symbol id="tab-geometry-right" viewBox="0 0 214 36">
              <use xlinkHref="#tab-geometry-left" />
            </symbol>
          </defs>
        </svg>
      </TabsList>
    </Tabs>
  );
}
